import type { IconProps } from '.';

/**
 * Quote Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const QuoteIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="22"
    viewBox="0 0 240 226"
    fill="none"
    className={className}
  >
    <path
      d="M240 0.00244141V226.002H136.665V103.401L240 0.00244141ZM103.335 0.00244141V226.002H0V103.401L103.335 0.00244141Z"
      fill="#FF4712"
    />
  </svg>
);

export default QuoteIcon;
